import { ObjectValues } from 'types/common';

export enum USER_TYPES {
  COACH = 'coach',
  USER = 'user',
  ADMIN = 'admin',
}

export type UserMode = ObjectValues<typeof USER_TYPES>;
